import React from 'react';

function Gap({
  as: Comp = 'div',
  isColumn = false,
  gap = '5px',
  className,
  ...rest
}) {
  return (
    <Comp
      {...rest}
      className={`fx ${isColumn ? 'col' : ''} ${className}`}
      style={{ ...rest.style, gap }}
    />
  );
}

function Row(props) {
  return <Gap {...props} isColumn={false} />;
}

function Column(props) {
  return <Gap {...props} isColumn />;
}

export { Row, Column };
